import React from 'react';
export function ProblemSection() {
  const problems = ['Reaccionás mal en situaciones que podrías manejar mejor', 'No entendés bien lo que sentís', 'Te sobrecargás emocionalmente', 'Te cuesta tomar decisiones con claridad', 'Sabés que tenés que cambiar… pero no sabés cómo'];
  return <section className="bg-brand-dark text-white py-5 px-5" data-id="element-234">
      <div className="max-w-xl mx-auto" data-id="element-235">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-3 leading-tight" data-id="element-236">
          😩 ¿Te pasa esto en el día a día?
        </h2>
        <p className="text-center text-brand-yellow font-bold text-lg mb-8" data-id="element-237">
          Te va a sonar familiar:
        </p>

        <div className="space-y-3 mb-10" data-id="element-238">
          {problems.map((problem, idx) => <div key={idx} className="bg-gray-900 border border-gray-800 p-4 rounded-xl flex items-start gap-3" data-id="element-239">
              <span className="text-red-500 text-lg flex-shrink-0" data-id="element-240">❌</span>
              <p className="text-sm text-gray-300 font-medium leading-relaxed" data-id="element-241">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-242">
          <h3 className="text-xl md:text-2xl font-bold text-brand-yellow mb-6" data-id="element-243">
            👉 ¿Cuánto tiempo más vas a seguir así?
          </h3>
        </div>
      </div>
    </section>;
}